import { Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsOptional, ValidateNested } from 'class-validator';

export class UserEmailNotificationsDto {
  @IsBoolean()
  securityAlerts!: boolean;

  @IsBoolean()
  chatMessages!: boolean;

  @IsBoolean()
  propertyActivity!: boolean;

  @IsBoolean()
  productUpdates!: boolean;

  @IsBoolean()
  weeklyDigest!: boolean;
}

export class UpdateUserEmailNotificationsDto {
  @IsBoolean()
  @IsOptional()
  securityAlerts?: boolean;

  @IsBoolean()
  @IsOptional()
  chatMessages?: boolean;

  @IsBoolean()
  @IsOptional()
  propertyActivity?: boolean;

  @IsBoolean()
  @IsOptional()
  productUpdates?: boolean;

  @IsBoolean()
  @IsOptional()
  weeklyDigest?: boolean;
}

export class UserNotificationSettingsDto {
  @ValidateNested()
  @Type(() => UserEmailNotificationsDto)
  @IsDefined()
  email!: UserEmailNotificationsDto;
}

export class UpdateUserNotificationSettingsDto {
  @ValidateNested()
  @Type(() => UpdateUserEmailNotificationsDto)
  @IsOptional()
  email?: UpdateUserEmailNotificationsDto;
}
